import React, { RefObject } from 'react';
import Anchor, { AnchorRef } from '@/components/ui/Anchor';
import cn from '@/utils/cn';
import TotalSlideShowScore from './TotalSlideShowScore';

interface TextVariablePopoverProps {
  locale: 'en' | 'es';
  popoverRef: RefObject<AnchorRef>;
  editorInstance: any;
}

const TextVariablePopover = ({
  locale,
  editorInstance,
  popoverRef,
} : TextVariablePopoverProps) => (
  <Anchor
    ref={popoverRef}
    attachListenersTo={[document.querySelector('.fr-wrapper')]}
    className="fr-popup fr-desktop"
    defaultOpen={false}
    offset={{ top: -40 }}
    position="bottom-left"
    to={document.getElementById(`TextVariable-${editorInstance.id}`)}
  >
    <div className="tw-w-[13rem] tw-bg-white tw-border tw-border-med-grey tw-border-solid">
      <p className={cn('tw-m-0 tw-font-semibold tw-text-[14px] tw-px-4 tw-py-2',
        'tw-border-b tw-border-med-grey tw-border-solid')}
      >
        Insert Text Variable:
      </p>
      <div className="tw-px-4 tw-py-2">
        <TotalSlideShowScore editorInstance={editorInstance} locale={locale} />
      </div>
    </div>
  </Anchor>
);

export default TextVariablePopover;
